import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { CorrespondenceEmailModel } from "../../../models/message-centre.models";
import { LookupValue } from "@rightship-tech/common-ui/models/lookup.models";
import { autoinject, computedFrom, observable } from "aurelia-framework";
import { ValidationController, ValidationControllerFactory, ValidationRules } from 'aurelia-validation';
import { CustomValidationRenderer } from '@rightship-tech/common-ui/client-validation-system/custom-validation-renderer';
import { RegexConstants } from '@rightship-tech/common-ui/constants/regex.constants';
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { EmailRecipientTypeEnum } from "../../../models/common.models";
import { RecipienthHelper } from "../../../helpers/recipient.helper";
@autoinject
export class DialogAddPeopleToThisConversation {

    public readonly defaultRightShipRecipient: string = "RightShip";
    public toEmails: CorrespondenceEmailModel[] = [];
    public tempToEmails: CorrespondenceEmailModel[] = [];
    public entityId: number;
    public entityTypeId: number;
    public isRightshipAlerted: boolean = false;

    @observable
    public selectedItems: LookupValue[] = [];

    @observable
    public selectedItemIds: number[] = [];

    @observable
    public itemSource: LookupValue[] = null;

    addPeopleToConversation: (emails: CorrespondenceEmailModel[]) => void;
    private _validator: ValidationController;

    constructor(private dialogClientService: DialogClientService, validationControllerFactory: ValidationControllerFactory
    ) {
        this._validator = validationControllerFactory.createForCurrentScope();
        this._validator.addRenderer(new CustomValidationRenderer());
    }

    activate(model: { entityId: number; isRightshipAlerted: boolean; entityTypeId: number, addPeopleToConversationFn: (emails: CorrespondenceEmailModel[]) => void, peopleAddedToConversation: CorrespondenceEmailModel[] }) {

        this.addPeopleToConversation = model.addPeopleToConversationFn;
        this.entityId = model.entityId;
        this.entityTypeId = model.entityTypeId;
        this.isRightshipAlerted = model.isRightshipAlerted;

        if (model.peopleAddedToConversation.length != 0) {
            this.toEmails = model.peopleAddedToConversation;
            this.tempToEmails = [...model.peopleAddedToConversation];
        }
    }

    getRules() {
        const emailRegex = new RegExp(RegexConstants.Patterns.EmailRfc5322);

        this.toEmails.forEach((email) => {
            ValidationRules
                .ensure('email')
                .required()
                .satisfies(email => {
                    return emailRegex.test(email)
                })
                .withMessage('Invalid Email - Acceptable format is <i>username@domain.com</i>')
                .on(email);
        });

        ValidationRules
            .ensure('selectedItems')
            .required()
            .satisfies(() => this.toEmails.length > 0)
            .withMessage('Email can not be empty')
            .on(this);
    }

    //SHOULD NOT CHANGE THE ITEMSOURCE VALUE
    itemSourceChanged() {

        if (!this.itemSource) return;

        //Select emails checked from the lookup
        const addedRecipientEmails = this.tempToEmails.filter(e => e.recipientTypeName).map(e => {
            return {
                email: e.email,
                recipientTypeName: e.recipientTypeName
            }
        });

        //Select items in the lookup that are already added to the conversation
        addedRecipientEmails.forEach(email => {

            //check if the email is already in the lookup
            let isEmailinLookup = false;
            this.itemSource.forEach(item => {
                if (item.additionalData.email === email.email && item.additionalData.recipientType === email.recipientTypeName) {
                    this.selectedItemIds.push(item.id);
                    isEmailinLookup = true;
                }
            });

            //If the email is not in the lookup, add it as a free text email
            if (!isEmailinLookup) {
                this.tempToEmails.push({
                    email: email.email,
                    emailRecipientTypeId: EmailRecipientTypeEnum.To,
                    recipientTypeName: ""
                });
            }
        });
    }

    selectedItemsChanged() {

        //Exclude the free text emails from the selected items
        const freeTextEmails = this.tempToEmails.filter(c => !c.recipientTypeName);

        this.tempToEmails = this.selectedItems.map(c => {
            const email = {
                email: c.additionalData.email,
                emailRecipientTypeId: EmailRecipientTypeEnum.To,
                recipientTypeName: c.additionalData.recipientType
            };
            return RecipienthHelper.checkRecipientType(email);
        });
        this.tempToEmails.push(...freeTextEmails);
    }

    close() {
        this.dialogClientService.hide();
    }

    addEmail() {
        this.tempToEmails.push({ email: "", emailRecipientTypeId: EmailRecipientTypeEnum.To, recipientTypeName: "" });
    }

    removeEmail(index: number, email: CorrespondenceEmailModel) {
        this.tempToEmails.splice(index, 1);
        if (this.selectedItems && this.selectedItems.length > 0) {
            this.selectedItems = this.selectedItems.filter(x => x.additionalData.email !== email.email || x.additionalData.recipientType !== email.recipientTypeName);
        }
    }

    async confirm() {

        //Validate email addresses
        this.getRules();
        const validator = await this._validator.validate();
        if (validator.valid) {
            this.toEmails = [...this.tempToEmails];
            this.addPeopleToConversation(this.toEmails);
            this.dialogClientService.hide();
        }
    }

    @computedFrom("entityTypeId")
    public get showSelectRecipients() {
        return this.entityTypeId == EntityTypes.PSC
    }
}